import { SyntheticEvent } from "react";

interface IHandleScroll {
  event: SyntheticEvent;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
}

const handleScroll = ({
  event,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: IHandleScroll) => {
  const listbox = event.currentTarget;
  const scrollPercentage =
    (listbox.scrollTop + listbox.clientHeight) / listbox.scrollHeight;

  // Load more when user has scrolled 80% of the way down
  if (scrollPercentage > 0.9 && hasNextPage && !isFetchingNextPage) {
    // eslint-disable-next-line
    void fetchNextPage();
  }
};
export default handleScroll;
